import { create } from "zustand";
import { usePagesStore } from "./pagesStore";

/**
 * Visibilidad del banner promocional del workspace. Sigue el patron del
 * proyecto de referencia: cuando el operador lo descarta, queda oculto
 * para la sesion de trabajo actual, pero cada vez que se entra de nuevo al
 * workspace (se abre la primera pestana) el banner vuelve, de modo que
 * cada sesion empieza con el aviso visible.
 */
interface BannerStoreState {
  visible: boolean;
  /** Oculta el banner para la sesion de trabajo actual. */
  dismiss: () => void;
  /** Restaura la visibilidad (lo usa la suscripcion de mas abajo). */
  reset: () => void;
}

export const useBannerStore = create<BannerStoreState>((set) => ({
  visible: true,
  dismiss: () => set({ visible: false }),
  reset: () => set({ visible: true }),
}));

// Restaura el banner cada vez que el workspace pasa de "sin pestanas" a
// "con pestanas" (se entra al espacio de trabajo). La suscripcion vive a
// nivel de modulo durante toda la vida de la app, igual que los stores.
let prevHadPages = usePagesStore.getState().pages.length > 0;
usePagesStore.subscribe((state) => {
  const hasPages = state.pages.length > 0;
  if (hasPages && !prevHadPages) {
    useBannerStore.getState().reset();
  }
  prevHadPages = hasPages;
});
